import {DASHBOARD_TILE_ID_SPLITS} from '../consts/dashboardTileIdSplits';
import {DashboardTileId} from '../types/DashboardTileId';
import {DashboardTilePlacement} from '../types/DashboardTilePlacement';

const PAIRED_TILE_IDS = Array.from(DASHBOARD_TILE_ID_SPLITS.values());

// The parts of a split tile share one half of the board by default. When only one of them is
// shown, it takes the whole half, so no empty quarter is left beside it.
export function widenUnpairedDashboardTiles(
  placements: DashboardTilePlacement[],
  visibleIds: DashboardTileId[]
): DashboardTilePlacement[] {
  const unpairedIds = PAIRED_TILE_IDS.flatMap((pair) => {
    const shown = pair.filter((id) => visibleIds.includes(id));

    return shown.length === 1 ? shown : [];
  });

  return placements.map((placement) =>
    unpairedIds.includes(placement.id) && placement.size === 'quarter'
      ? {...placement, size: 'half'}
      : placement
  );
}
